import styled from "styled-components";
import { Wrapper } from "AppReact";
import device from "utils/device";

const template = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 0px 0px 50% 50%;
  padding: 12px;

  @media ${device.tablet} {
    width: 145px;
    height: 145px;
    border-radius: 0px 0px 50% 50%;
    padding: 20px;
  }
`;

export default Wrapper(template)
